import React, { useEffect } from "react";

import "../css/ChatBot.css";

const Chatbot = () => {
  return (
    <div className="chat-bot">
      <a
        href="https://dzb28dty6bryq.cloudfront.net/index.html"
        className="chatbot-bot"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ask my career BOT any questions you may have.
      </a>
    </div>
  );
};

export default Chatbot;
